import { SITE_ORIGIN } from '@/utlis/siteConfig';
import { guidePosts } from '@/documents/guides.js';

export const troubleshootingPosts = [
  {
    title: 'GB WhatsApp Not Installing? Common Fixes',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'Fix APK install errors, unknown sources, and storage issues.',
    name: 'trouble-install',
    url: `${SITE_ORIGIN}/gb-whatsapp-not-installing/`,
    path: '/gb-whatsapp-not-installing/',
    date: '2026-07-04',
    publishedAt: '2026-07-04T09:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'GB WhatsApp Verification Failed Solutions',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'OTP, network, and cache fixes for verification problems.',
    name: 'trouble-verify',
    url: `${SITE_ORIGIN}/gb-whatsapp-verification-failed/`,
    path: '/gb-whatsapp-verification-failed/',
    date: '2026-07-05',
    publishedAt: '2026-07-05T09:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'GB WhatsApp Update Failed? Fix Update Errors',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'Learn how to fix APK update errors, compatibility issues, and installation problems.',
    name: 'trouble-update',
    url: `${SITE_ORIGIN}/gb-whatsapp-update-failed/`,
    path: '/gb-whatsapp-update-failed/',
    date: '2026-07-06',
    publishedAt: '2026-07-06T09:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'GB WhatsApp Chat Backup Not Working? Easy Fixes',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'GB WhatsApp chat backup not working or getting stuck? Try these simple fixes for backup errors, missing files, and failed backups.',
    name: 'trouble-chat-backup-not-working',
    url: `${SITE_ORIGIN}/gb-whatsapp-chat-backup-not-working/`,
    path: '/gb-whatsapp-chat-backup-not-working/',
    date: '2026-09-03',
    publishedAt: '2026-09-03T09:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'GB WhatsApp Chats Not Restoring After Reinstall? Easy Fixes',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'GB WhatsApp chats not restoring after reinstalling? Check backup files, storage, permissions, folder locations, and version compatibility.',
    name: 'trouble-chats-not-restoring',
    url: `${SITE_ORIGIN}/gb-whatsapp-chats-not-restoring/`,
    path: '/gb-whatsapp-chats-not-restoring/',
    date: '2026-09-03',
    publishedAt: '2026-09-03T10:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'GB WhatsApp Notifications Not Working? Easy Fixes',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'GB WhatsApp notifications not working or delayed? Check notification permissions, battery settings, background data, and other easy fixes.',
    name: 'trouble-notifications-not-working',
    url: `${SITE_ORIGIN}/gb-whatsapp-notifications-not-working/`,
    path: '/gb-whatsapp-notifications-not-working/',
    date: '2026-09-03',
    publishedAt: '2026-09-03T11:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'Why Is GB WhatsApp Not Sending the SMS Code?',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'Why is your GB WhatsApp SMS code not arriving? Check your phone number, mobile signal, carrier settings, and verification timer to troubleshoot the issue.',
    name: 'trouble-sms-code-not-received',
    url: `${SITE_ORIGIN}/gb-whatsapp-sms-code-not-received/`,
    path: '/gb-whatsapp-sms-code-not-received/',
    date: '2026-10-21',
    publishedAt: '2026-10-21T09:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'Why Does GB WhatsApp Keep Crashing on Android?',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'Why does GB WhatsApp keep crashing or freezing? Check storage, clear temporary cache files, review Android compatibility, and protect your chats before reinstalling.',
    name: 'trouble-keeps-crashing',
    url: `${SITE_ORIGIN}/gb-whatsapp-keeps-crashing/`,
    path: '/gb-whatsapp-keeps-crashing/',
    date: '2026-10-21',
    publishedAt: '2026-10-21T10:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'Is GB WhatsApp Safe? Security and Privacy Risks',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'Is GB WhatsApp safe to use? Review APK security, privacy concerns, account restrictions, and chat backup risks before installing a modified app.',
    name: 'trouble-is-gb-whatsapp-safe',
    url: `${SITE_ORIGIN}/is-gb-whatsapp-safe/`,
    path: '/is-gb-whatsapp-safe/',
    date: '2026-10-21',
    publishedAt: '2026-10-21T11:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
  {
    title: 'How Can You Avoid GB WhatsApp Account Restrictions?',
    poster: require('@/assets/gb-wave-logo.webp'),
    desc: 'How can you reduce WhatsApp account restriction risks? Understand unofficial app risks, avoid spam, protect your chats, and follow official support instructions.',
    name: 'trouble-avoid-account-restrictions',
    url: `${SITE_ORIGIN}/avoid-gb-whatsapp-account-restrictions/`,
    path: '/avoid-gb-whatsapp-account-restrictions/',
    date: '2026-10-21',
    publishedAt: '2026-10-21T12:00:00Z',
    category: 'troubleshooting',
    published: true,
  },
];

export default {
  bloglist: {
    en: [
      ...guidePosts,
      ...troubleshootingPosts,
    ],
  },
};
